import React, { PropTypes } from "react";
import moment from "moment";
import Avatar from "components/Avatar/Avatar";
import CertificateLink from "components/CpdLocker/CertificateLink.jsx";
import { CPDPoints, cpdPoints } from "components/CPDPoints";
import constants from "constants";
import renderSponsors from "components/Dashboard/renderSponsors";
import renderExperts from "components/Dashboard/renderExperts";
import renderPartners from "components/Dashboard/renderPartners";
import WebinarSponsorsRepresentative from "../../WebinarSponsorsRepresentative";

const { CPD_STATUSES } = constants;

const PreviousWebinarItem = ({
  webinar: {
    webinar_title,
    start_date,
    end_date,
    vimeo_url,
    partnerships,
    sponsor,
    sponsors,
    joined,
    is_quiz_completed,
    cpd_status,
    experts,
    id,
  },
  webinar,
  token,
  subscriptionAction,
  isMobile,
}) => {
  const isCertificateOfParticipation =
    webinar.ref_type === "certificate_of_participation";

  const isCustomCertificate = isCertificateOfParticipation;

  if (isMobile) {
    return (
      <div
        className="section_previous"
        onClick={vimeo_url && subscriptionAction}
        key={`previous_webinars_${id}`}
      >
        <p className="section_topic">{webinar_title}</p>
        <div className="section_info_mobile">
          <div className="section_topic_mobile">
            {webinar.vimeo_url && webinar.duration ? (
              <div>
                <p className="current_card_date">Duration</p>
                <p className="current_card_time">{webinar.duration || "N/A"}</p>
              </div>
            ) : (
              <div>
                <p className="current_card_date">
                  <span>
                    {moment(start_date).format("MMM DD").toUpperCase()}{" "}
                  </span>
                  {moment(start_date).format("YYYY")}
                </p>
                <p className="current_card_time">
                  {moment(start_date).format("h:mm a").toUpperCase()}
                  {" - "}
                  {moment(end_date).format("h:mm a").toUpperCase()}
                </p>
              </div>
            )}
            {webinar && webinar.document_url ? (
              <div className="col l1">
                <div className="current_points">
                  Agenda:{" "}
                  <a
                    className="download_attachment"
                    target="_blank"
                    href={webinar.document_url}
                  >
                    Download
                  </a>
                </div>
              </div>
            ) : null}
            {webinar && webinar.ppt_document_url ? (
              <div className="col l1">
                <div className="current_points">
                  Resources:{" "}
                  <a
                    className="download_attachment"
                    target="_blank"
                    href={webinar.ppt_document_url}
                  >
                    Download
                  </a>
                </div>
              </div>
            ) : null}
          </div>
          {renderExperts(experts)}
          <div className="section_sponsors_mobile">
            <div>
              {sponsors && sponsors.length && sponsors.length > 0 ? (
                <div>
                  <p>Brought to you by:</p>
                  {renderSponsors(sponsor, sponsors, false)}
                </div>
              ) : null}
            </div>
            <div className="section_sponsors_join">
              {webinar && webinar.cpd_points && !isCustomCertificate ? (
                <CPDPoints webinar={webinar} />
              ) : null}

              {isCustomCertificate && <p>Certificate of Participation</p>}

              {(joined || is_quiz_completed) &&
                (cpd_status === CPD_STATUSES.granted ||
                  isCustomCertificate) && (
                  <CertificateLink token={token} webinarId={webinar.id} />
                )}
            </div>
          </div>
          {partnerships && partnerships.length && partnerships.length > 0 ? (
            <div className="partnership-title-mobile">
              <p>In partnership with:</p>
              {renderPartners(partnerships)}
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <div
      className="section_previous"
      onClick={vimeo_url && subscriptionAction}
      key={`previous_webinars_${id}`}
    >
      <p className="section_topic">{webinar_title}</p>
      <div className="section_info row">
        <div className="col l3 webinar_title">
          <p className="section_previous_theme"></p>
          {partnerships && partnerships.length && partnerships.length > 0 ? (
            <div>
              <p>In partnership with:</p>
              {renderPartners(partnerships)}
            </div>
          ) : null}
        </div>
        {/* {Boolean(webinar.sponsor_representative.length) && (
          <div className="col l2">
            <WebinarSponsorsRepresentative
              sponsors={webinar.sponsor_representative}
            />
          </div>
        )} */}
        {webinar && webinar.ppt_document_url ? (
          <div className="col l1">
            <div className="current_points">
              Resources:
              <a
                className="download_attachment"
                target="_blank"
                href={webinar.ppt_document_url}
              >
                Download
              </a>
            </div>
          </div>
        ) : null}
        {webinar.vimeo_url && webinar.duration ? (
          <div className="col l2">
            <p className="current_card_date">Duration</p>
            <p className="current_card_time">{webinar.duration || "N/A"}</p>
          </div>
        ) : (
          <div className="col l2">
            <p className="current_card_date">
              <span>{moment(start_date).format("MMM DD").toUpperCase()} </span>
              {moment(start_date).format("YYYY")}
            </p>
            <p className="current_card_time">
              {moment(start_date).format("h:mm a").toUpperCase()}
              {" - "}
              {moment(end_date).format("h:mm a").toUpperCase()}
            </p>
          </div>
        )}
        <div className="col l2">
          {sponsors && sponsors.length && sponsors.length > 0 ? (
            <div>
              <p>Brought to you by:</p>
              {renderSponsors(sponsor, sponsors, false)}
            </div>
          ) : null}
        </div>
        {webinar && webinar.cpd_points && !isCustomCertificate ? (
          <div className="col l1">
            <p className="section_previous_points">CPD Points:</p>
            <br />
            <p>{cpdPoints(webinar)}</p>
          </div>
        ) : null}

        {isCustomCertificate && (
          <div className="col l1">
            <p>Certificate of Participation</p>
          </div>
        )}

        <div className="col l1">
          {(joined || is_quiz_completed) &&
            (cpd_status === CPD_STATUSES.granted || isCustomCertificate) && (
              <CertificateLink token={token} webinarId={webinar.id} />
            )}
        </div>
      </div>
      {/*<a href="javascript:void(0)" onClick={vimeo_url && subscriptionAction}></a>*/}
      {renderExperts(experts)}
    </div>
  );
};

PreviousWebinarItem.propTypes = {
  // webinar: PropTypes.obj,
};

export default PreviousWebinarItem;



// WEBPACK FOOTER //
// ./src/components/Dashboard/PreviousWebinars/PreviousWebinarItem.js